module.exports = __webpack_public_path__ + "img/soon.60f7bf8a.png";